import { FieldInputProps } from 'formik';
import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { Input } from 'style/styleInput.style';

const formatInput = (value: string) => {
  return value.trim().slice(0, 15);
};

const InputPhoneNumber = React.forwardRef<
  HTMLInputElement,
  FieldInputProps<string> & NumericFormatProps
>((props, ref) => {
  const { customInput = Input, ...otherProps } = props;

  return (
    <NumericFormat
      {...otherProps}
      valueIsNumericString
      inputMode="numeric"
      autoComplete="off"
      spellCheck="false"
      autoCorrect="off"
      customInput={customInput}
      allowNegative={false}
      maxLength={15}
      getInputRef={ref}
    />
  );
});

InputPhoneNumber.displayName = 'InputPhoneNumber';

export default InputPhoneNumber;
